module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "integration-code"
  }, [_c('p', {
    staticClass: "info"
  }, [_vm._v("Position: ")]), _vm._v(" "), _vm._l((_vm.types), function(item) {
    return [_c('div', {
      key: item,
      staticClass: "field field-select"
    }, [_c('div', {
      staticClass: "check-round"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.type),
        expression: "type"
      }],
      attrs: {
        "id": item,
        "type": "radio"
      },
      domProps: {
        "value": item,
        "checked": _vm._q(_vm.type, item)
      },
      on: {
        "change": function($event) {
          _vm.type = item
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": item
      }
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.texts[item]))])])]
  }), _vm._v(" "), (_vm.type === 'topBar' || _vm.type === 'bottomCorner') ? _c('div', {
    staticClass: "integration-description"
  }, [_c('p', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.texts["descriptionLabel"]))]), _vm._v(" "), _c('div', {
    staticClass: "field emoji speech"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "input-text shadow",
    attrs: {
      "placeholder": _vm.texts['descriptionPlaceholder'],
      "type": "text"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('CodeBox', {
    attrs: {
      "cdnPath": _vm.cdnPath,
      "description": _vm.description,
      "slug": _vm.slug,
      "texts": _vm.texts,
      "type": _vm.type
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c34e90c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/packs/questions/tools/integrator/index.vue
// module id = 466
// module chunks = 0 8